import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { catchError, throwError } from 'rxjs';

/** Mensagem de erro do envelope da API: `errors[0]` ou, na falta, `message`. */
const obterMensagemApi = (err: HttpErrorResponse): string | null => {
  if (Array.isArray(err.error?.errors) && err.error.errors.length > 0) return err.error.errors[0];
  return err.error?.message || null;
}

export const interceptorInterceptor: HttpInterceptorFn = (req, next) => {

  const _toastr = inject(ToastrService);

  return next(req).pipe(
    catchError((err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 400) {
          const mensagem = obterMensagemApi(err);
          if (mensagem) _toastr.error(mensagem, "Algo deu errado!")
        }else if (err.status === 401) {
          _toastr.error("Sem permissão para essa ação", "Acesso negado")
        }else if (err.status === 403) {
          _toastr.error(obterMensagemApi(err) || "Você não tem permissão para essa ação", "Acesso negado")
        }else if (err.status === 404) {
          _toastr.error("Nenhum resultado encontrado.", "Nenhum Resultado")
        }else if (err.status === 409) {
          _toastr.error(obterMensagemApi(err) || "O registro conflita com um já existente.", "Algo deu errado!")
        }else if (err.status === 500) {
          _toastr.error(err.message, "Erro Interno")
        }
      } else {
        console.error('Ocorreu um erro:', err);
      }
      return throwError(() => err);
    })
  )
};
